/*
 * @Date: 2020-08-20 11:13:13
 * @Author: MX
 * @LastEditTime: 2023-03-23 11:41:25
 * @Description: 路由
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//以下代码解决路由地址重复的报错问题
// const originalPush = VueRouter.prototype.push
//    VueRouter.prototype.push = function push(location) {
//    return originalPush.call(this, location).catch(err => err)
// }

const routes = [
    //首页
  {
    path: '/',
    redirect: {
		name: 'Home',
	}
  },
  {
    path: '/home',
    name: 'Home',
    meta:{pathSet:"/home"},
    component: () => import("@/views/home/Home.vue")
  },
  //注册
  {
    path: '/register',
    name: 'Register',
    component: () => import("@/views/login/Register.vue")
  },
  //登录
  {
    path: '/login',
    name: 'Login',
    component: () => import("@/views/login/Login.vue")
  },
  {
    path: '/forgetPassword',
    name: 'ForgetPassword',
    component: () => import("@/views/login/ForgetPassword.vue")
  },
  //api文档
  {
    path: '/apiDoc',
    name: 'ApiDoc',
    redirect:{name:'apiDocIndex'},
    component: () => import("@/views/apiDoc/Index.vue"),
    children:[{
      path:"/apiDoc/index",
      name:"apiDocIndex",
      meta:{pathSet:"/apiDoc",title:"极兔API简介"},
      component:() => import("@/views/apiDoc/apiDocIndex.vue"),
    },{
      path:"/apiDoc/basic",
      name:"basic",
      meta:{pathSet:"/apiDoc",title:"获取极兔省市区"},
      component:() => import("@/views/apiDoc/children/basic/index.vue"),
    },{
      path:"/apiDoc/orderserve/create",
      name:"createOrder",
      meta:{pathSet:"/apiDoc",title:"创建订单"},
      component:() => import("@/views/apiDoc/children/orderserve/create.vue"),
    },{
      path:"/apiDoc/orderserve/query",
      name:"queryOrder",
      meta:{pathSet:"/apiDoc",title:"查询订单"},
      component:() => import("@/views/apiDoc/children/orderserve/query.vue"),
    },{
      path:"/apiDoc/orderserve/cancel",
      name:"cancelOrder",
      meta:{pathSet:"/apiDoc",title:"取消订单"},
      component:() => import("@/views/apiDoc/children/orderserve/cancel.vue"),
    },
    {
      path:"/apiDoc/orderserve/statusFeedback",
      name:"orderStatusFeedback",
      meta:{pathSet:"/apiDoc",title:"订单状态回传"},
      component:() => import("@/views/apiDoc/children/orderserve/statusFeedback.vue"),
    },
    {
      path:"/apiDoc/orderserve/addLooseOrder",
      name:"addLooseOrder",
      meta:{pathSet:"/apiDoc",title:"订单状态回传"},
      component:() => import("@/views/apiDoc/children/orderserve/addLooseOrder.vue"),
    },
    {
      path:"/apiDoc/orderserve/expressquery",
      name:"expressquery",
      meta:{pathSet:"/apiDoc",title:"面单模版查询"},
      component:() => import("@/views/apiDoc/children/orderserve/expressQuery.vue"),
    },
    {
      path:"/apiDoc/orderserve/expressquerynew",
      name:"expressquerynew",
      meta:{pathSet:"/apiDoc",title:"面单模版查询（新）"},
      component:() => import("@/views/apiDoc/children/orderserve/expressQueryNew.vue"),
    },
    {
      path:"/apiDoc/orderserve/returnApplication",
      name:"expressquery",
      meta:{pathSet:"/apiDoc",title:"退回件申请"},
      component:() => import("@/views/apiDoc/children/orderserve/returnApplication.vue"),
    },
    {
      path:"/apiDoc/orderserve/returnAndExchange",
      name:"returnAndExchange",
      meta:{pathSet:"/apiDoc",title:"退换货接口"},
      component:() => import("@/views/apiDoc/children/orderserve/returnAndExchange.vue"),
    },
    {
      path:"/apiDoc/orderserve/internationalExport",
      name:"internationalExport",
      meta:{pathSet:"/apiDoc",title:"出口国际件"},
      component:() => import("@/views/apiDoc/children/orderserve/internationalExport.vue"),
    },
    {
      path:"/apiDoc/vip/query",
      name:"vipQuery",
      meta:{pathSet:"/apiDoc",title:"电子面单账号检验"},
      component:() => import("@/views/apiDoc/children/vip/query.vue"),
    },
    {
      path:"/apiDoc/vip/balance",
      name:"vipBalance",
      meta:{pathSet:"/apiDoc",title:"电子面单余额查询"},
      component:() => import("@/views/apiDoc/children/vip/balance.vue"),
    },
    {
      path:"/apiDoc/vip/getwaybill",
      name:"vipGetwaybill",
      meta:{pathSet:"/apiDoc",title:"获取电子面单"},
      component:() => import("@/views/apiDoc/children/vip/getwaybill.vue"),
    },{
      path:"/apiDoc/logistics/query",
      name:"logisticsQuery",
      meta:{pathSet:"/apiDoc",title:"物流轨迹查询"},
      component:() => import("@/views/apiDoc/children/logistics/query.vue"),
    },
    {
      path:"/apiDoc/logistics/statusFeedback",
      name:"logisticsStatusFeedback",
      meta:{pathSet:"/apiDoc",title:"物流轨迹回传"},
      component:() => import("@/views/apiDoc/children/logistics/statusFeedback.vue"),
    },{
      path:"/apiDoc/logistics/subscribe",
      name:"logisticsSubscribe",
      meta:{pathSet:"/apiDoc",title:"物流轨迹订阅"},
      component:() => import("@/views/apiDoc/children/logistics/subscribe.vue"),
    },{
      path:"/apiDoc/other/cover",
      name:"othercover",
      meta:{pathSet:"/apiDoc",title:"超区查询"},
      component:() => import("@/views/apiDoc/children/other/cover.vue"),
    },{
      path:"/apiDoc/other/pca",
      name:"otherpca",
      meta:{pathSet:"/apiDoc",title:"收派范围查询"},
      component:() => import("@/views/apiDoc/children/other/pca.vue"),
    },{
      path:"/apiDoc/other/getInfo",
      name:"othergetInfo",
      meta:{pathSet:"/apiDoc",title:"网点信息及三段码查询"},
      component:() => import("@/views/apiDoc/children/other/getInfo.vue"),
    },{
      path:"/apiDoc/other/settlementReturn",
      name:"settlementReturn",
      meta:{pathSet:"/apiDoc",title:"结算账单回传"},
      component:() => import("@/views/apiDoc/children/other/settlementReturn.vue"),
    },{
      path:"/apiDoc/other/realNameSaveInfo",
      name:"realNameSaveInfo",
      meta:{pathSet:"/apiDoc",title:"实名制信息上传"},
      component:() => import("@/views/apiDoc/children/other/realNameSaveInfo.vue"),
    },
    {
      path:"/apiDoc/other/freight",
      name:"freight",
      meta:{pathSet:"/apiDoc",title:"运费计算"},
      component:() => import("@/views/apiDoc/children/other/freight.vue"),
    },
    {
      path:"/apiDoc/other/threeSegmentCode",
      name:"threeSegmentCode",
      meta:{pathSet:"/apiDoc",title:"三段码查询"},
      component:() => import("@/views/apiDoc/children/other/threeSegmentCode.vue"),
    },
    {
      path:"/apiDoc/other/expressDelivery",
      name:"expressDelivery",
      meta:{pathSet:"/apiDoc",title:"快件预报"},
      component:() => import("@/views/apiDoc/children/other/expressDelivery.vue"),
    },
    {
      path:"/apiDoc/other/flight",
      name:"flight",
      meta:{pathSet:"/apiDoc",title:"航空预报"},
      component:() => import("@/views/apiDoc/children/other/flight.vue"),
    },
    {
      path:"/apiDoc/other/expressDeliveryDelete",
      name:"expressDeliveryDelete",
      meta:{pathSet:"/apiDoc",title:"快件预报删除"},
      component:() => import("@/views/apiDoc/children/other/expressDeliveryDelete.vue"),
    },
    {
      path:"/apiDoc/other/freightCost",
      name:"freightCost",
      meta:{pathSet:"/apiDoc",title:"预估运费查询"},
      component:() => import("@/views/apiDoc/children/other/freightCost.vue"),
    },
    {
      path:"/apiDoc/other/subscribe",
      name:"subscribe",
      meta:{pathSet:"/apiDoc",title:"代收货款订阅"},
      component:() => import("@/views/apiDoc/children/other/subscribe.vue"),
    },
    {
      path:"/apiDoc/other/subscribeOther",
      name:"subscribeOther",
      meta:{pathSet:"/apiDoc",title:"代收货款回传"},
      component:() => import("@/views/apiDoc/children/other/subscribeOther.vue"),
    },
    {
      path:"/apiDoc/other/recheduleDelivery",
      name:"recheduleDelivery",
      meta:{pathSet:"/apiDoc",title:"预约派送"},
      component:() => import("@/views/apiDoc/children/other/recheduleDelivery.vue"),
    },
    // 清关服务 ---- 清关小包下发
    {
      path:"/apiDoc/customsClearance/smallPackageDistribute",
      name:"smallPackageDistribute",
      meta:{pathSet:"/apiDoc",title:"清关小包下发"},
      component:() => import("@/views/apiDoc/children/customsClearance/smallPackageDistribute.vue"),
    },
    // 清关单下发
    {
      path:"/apiDoc/customsClearance/customsClearanceIssued",
      name:"customsClearanceIssued",
      meta:{pathSet:"/apiDoc",title:"清关单下发"},
      component:() => import("@/views/apiDoc/children/customsClearance/customsClearanceIssued.vue"),
    },
    // 清关单取消
    {
      path:"/apiDoc/customsClearance/customsClearanceCancelled",
      name:"customsClearanceCancelled",
      meta:{pathSet:"/apiDoc",title:"清关单取消"},
      component:() => import("@/views/apiDoc/children/customsClearance/customsClearanceCancelled.vue"),
    },
    // 清关单查询
    {
      path:"/apiDoc/customsClearance/customsClearanceQuery",
      name:"customsClearanceQuery",
      meta:{pathSet:"/apiDoc",title:"清关单查询"},
      component:() => import("@/views/apiDoc/children/customsClearance/customsClearanceQuery.vue"),
    }
  ]
  },
  //个人中心
  {
      path:"/personalCenter",
      name:"PersonalCenter",
      component: () => import("@/views/personalCenter/Index.vue")
  },
  //控制台
  {
    path:"/control",
    name:"Control",
    meta:{pathSet:"/control"},
    component: () => import("@/views/control/Index.vue")
  },
  {
    path:"/helpCenter",
    name:"HelpCenter",
    meta:{pathSet:"/helpCenter"},
    component: () => import("@/views/helpCenter/Index.vue")
  },
  // 管我们
  {
    path:"/aboutUs",
    name:"AboutUs",
    meta:{pathSet:"/aboutUs"},
    component: () => import("@/views/aboutUs/Index.vue")
  }
]

const router = new VueRouter({
//   mode: 'history',
  routes
})

export default router
